import { Component, OnInit, Input, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatTable, PageEvent } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from '../_service/user.service';
import { AlertifyService } from '../_service/alertify.service';
import { HttpClient } from '@angular/common/http';
import { AddSiteComponent } from './add-site/add-site.component';
import { EditSiteComponent } from './edit-site/edit-site.component';
import { AddLocationComponent } from './add-location/add-location.component';
import { AddDepartmentComponent } from './add-department/add-department.component';
import { AuthoritytreeService } from '../_service/authoritytree.service';
import { AddSubDepartmentComponent } from './add-subDepartment/add-subDepartment.component';
import { AddFloorComponent } from './add-floor/add-floor.component';
import { LocationService } from '../_service/location.service';
import { AddAuthorityComponent } from './add-authority/add-authority.component';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../_service/auth.service';

@Component({
  selector: 'authority',
  templateUrl: './authority.component.html',
  styleUrls: ['./authority.component.css']
})
export class AuthorityComponent implements OnInit {
 
  
  constructor(
    private userService: UserService,
    private locationService: LocationService,
    private alertify: AlertifyService,
    private http: HttpClient,
    private dialog: MatDialog,
    private authorityTreeService: AuthoritytreeService,
    public fb: FormBuilder,
    private authService: AuthService
  ) {
    this.searchBarForm = fb.group({
      searchStringControl:  new FormControl({value: '', disabled: false}, []),
    });

  }

  MyDataSource: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;

  dataChange: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  isLoading = false;

    dataSource: any;
    selectedAddNewSite: any;
    authority: any = [];
    allAuthorities: any = [];
    authorities;
    authorityFilter = true;
    authArrayIds: any = [];
    authTreeArray: any =  [];
    authorityTree;
    level1Authorities;
    level2Authorities;
    level3Authorities;
    public selectedAuthority: any;
    public selectedLevel1Authority: any;
    public selectedLevel2Authority: any;
    public selectedLevel3Authority: any;
    departmentCount: number;
    hideLevel3DropDown: boolean;
    searchString;
    selectedSearchParameter;
    selectedParameter: any;;
    searchBarForm: FormGroup;
    value = '';
    message: any;
    errorMessage = false;
    invalidSearch: any = {};

  sites = [
    { value: 'Select', viewValue : 'Select' },
    { value: 'Authority', viewValue : 'Site' },
    { value: 'Site', viewValue : 'Service area' },
    { value: 'Location', viewValue : 'Location' },
    { value: 'Department', viewValue : 'Sub-location' },
    { value: 'Sub-department', viewValue : 'Department' },
    { value: 'Floor', viewValue : 'Sub-department' }
  ];

  displayedColumns: string[] = [
    'topLevelName',
    'subTopLevelName',
    'hospitalLevelName',
    'departmentLevelName',
    'departmentLevelChildName',
    'floorLevelName'
    // 'Edit'
  ];

  @Input() totalCount: number;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Input() totalPages: number[];
  @Input() pageIndex: number;
  @Input() pageSizeOptions: number[] = [5, 10, 20];
  @Input() pageSize: number;
  @Input() nextPage: number;
  @Input() previousPage: number;

  unsubscribe = new Subject<void>();

  ngOnInit() {
    // this.getAllAuthorityLocations();
    this.selectedAddNewSite = 'Select';
    this.selectedParameter = 'allLocations';
    this.disableSearchbox(); // Set initial disabled state
    console.log(this.getUserid());
  }

  setLoadingState = (isLoading) => {};

  applyFilter(filterValue: string) {
    this.MyDataSource.filter = filterValue.trim().toLowerCase();
  }

  openAuthorityDialog(authority) {
    const dialogRef = this.dialog.open(AddAuthorityComponent, {
      width: '500px',
      data: {
        authority: authority
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectedAddNewSite = 'Select';
      // isModified comes from edit-site Component.
      // returns true or false
      if (dialogRef.componentInstance.isModified) {
        this.getAllAuthorityLocations();
      }
    });
  }

openDiaglog1(authority) {
  const dialogRef = this.dialog.open(AddSiteComponent, {
    width: '500px',
    data: {
      authority: authority
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    this.selectedAddNewSite = 'Select';
    // isModified comes from edit-site Component.
    // returns true or false
    if (dialogRef.componentInstance.isModified) {
      this.getAllAuthorityLocations();
    }
  });
}

openDiaglogEdit(authority) {

  this.editClick(authority.topLevelId);
  const dialogRef = this.dialog.open(EditSiteComponent, {
    data: {
      authority: authority
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    this.selectedAddNewSite = 'Select';

    // isModified comes from edit-site Component.
    // returns true or false
    if (dialogRef.componentInstance.isModified) {
      this.getAllAuthorityLocations();
    }
  });
}

openDialogLocation(authority) {
  
  const dialogRef = this.dialog.open(AddLocationComponent, {
    width: '500px',
    data: {
      authority: authority
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    this.selectedAddNewSite = 'Select';
    // isModified comes from edit-site Component.
    // returns true or false
    if (dialogRef.componentInstance.isModified) {
      this.getAllAuthorityLocations();
    }
  });
}

openDialogDepartment(authority) {
  const dialogRef = this.dialog.open(AddDepartmentComponent, {
    width: '500px',
    data: {
      authority: authority
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    this.selectedAddNewSite = 'Select';
    // isModified comes from edit-site Component.
    // returns true or false
    if (dialogRef.componentInstance.isModified) {
      this.getAllAuthorityLocations();
    }
  });
}

openDialogSubDepartment(authority) {
  const dialogRef = this.dialog.open(AddSubDepartmentComponent, {
    width: '500px',
    data: {
      authority: authority
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    this.selectedAddNewSite = 'Select';
    // isModified comes from edit-site Component.
    // returns true or false
    if (dialogRef.componentInstance.isModified) {
      this.getAllAuthorityLocations();
    }
  });
}

openDialogFloor(authority) {
  const dialogRef = this.dialog.open(AddFloorComponent, {
    width: '500px',
    data: {
      authority: authority
    }
  });
  dialogRef.afterClosed().subscribe(result => {
    this.selectedAddNewSite = 'Select';
    // isModified comes from edit-site Component.
    // returns true or false
    if (dialogRef.componentInstance.isModified) {
      this.getAllAuthorityLocations();
    }
  });
}

isSiteAdmin() {
  if (this.authService.decodedToken.role === 'Site Admin') {
    return true;
  } else {
    return false;
  }
}

showColumn() {
  if (this.authService.decodedToken.role === 'Site Admin') {
    return 'none';
  } else {
    return null;
  }
}

onSelectParameter(event) {
  this.selectedSearchParameter = event.value;
}

disableSearchbox() {
  if (this.selectedParameter === 'allLocations') {
    this.value = '';
    this.searchString = '';
    this.searchBarForm.controls['searchStringControl'].disable();
  } else {
    this.searchBarForm.controls['searchStringControl'].enable();
  }
}

clearInputBox() {
  this.value = '';
  this.searchString = '';
  this.searchBarForm.controls['searchStringControl'].setValue('');
}

disableButton() {
  if (this.selectedParameter === 'none') {
    return true;
  } else {
    return false;
  }
}

restrictDropDownParams() {
  if (this.selectedSearchParameter === 'authoritylevel' && this.searchString === '') {
    this.isLoading = false;
    this.setLoadingState(false);
    this.alertify.message('Please enter a search parameter');
    return false;
  }
  if (this.selectedSearchParameter === 'sitelevel' && this.searchString === '') {
    this.isLoading = false;
    this.setLoadingState(false);
    this.alertify.message('Please enter a search parameter');
    return false;
  }
  if (this.selectedSearchParameter === 'locationlevel' && this.searchString === '') {
    this.isLoading = false;
    this.setLoadingState(false);
    this.alertify.message('Please enter a search parameter');
    return false;
  }
  if (this.selectedSearchParameter === 'departmentlevel' && this.searchString === '') {
    this.isLoading = false;
    this.setLoadingState(false);
    this.alertify.message('Please enter a search parameter');
    return false;
  }
  if (this.selectedSearchParameter === 'subDepartmentlevel' && this.searchString === '') {
    this.isLoading = false;
    this.setLoadingState(false);
    this.alertify.message('Please enter a search parameter');
    return false;
  }
  if (this.selectedSearchParameter === 'floorlevel' && this.searchString === '') {
    this.isLoading = false;
    this.setLoadingState(false);
    this.alertify.message('Please enter a search parameter');
    return false;
  } else {
    return true;
  }
}

searchForLocations(selectedValue: string) {
  this.allAuthorities = [];
  this.searchString = selectedValue;
  const obj: SearchObject = {
    searchAuthorityLevel: '',
    searchSiteLevel: '',
    searchLocationLevel: '',
    searchDepartmentLevel: '',
    searchSubDepartmentLevel: '',
    searchFloorLevel: ''
  };

  if (this.selectedSearchParameter === 'authoritylevel') {
    obj.searchAuthorityLevel = selectedValue;
  }
  if (this.selectedSearchParameter === 'sitelevel') {
    obj.searchSiteLevel = selectedValue;
  }
  if (this.selectedSearchParameter === 'locationlevel') {
    obj.searchLocationLevel = selectedValue;
  }
  if (this.selectedSearchParameter === 'departmentlevel') {
    obj.searchDepartmentLevel = selectedValue;
  }
  if (this.selectedSearchParameter === 'subDepartmentlevel') {
    obj.searchSubDepartmentLevel = selectedValue;
  }
  if (this.selectedSearchParameter === 'floorlevel') {
    obj.searchFloorLevel = selectedValue;
  }
  this.paginator.firstPage();
  this.getAllAuthorityLocations();
}

invalidSearchResultMessage(message) {
  if (message) {
    this.message = message;
    this.isLoading = false;
  } else {
    this.message = '';
  }
}

  onUserSelectAddNew(userSelection) {
    if (userSelection === 'Authority') {
      this.openAuthorityDialog('Authority');
    } else if (userSelection === 'Site') {
      this.openDiaglog1('myAuthority')
    } else if (userSelection === 'Location') {
      this.openDialogLocation(userSelection);
    } else if (userSelection === 'Department') {
      this.openDialogDepartment('my authority');
    } else if (userSelection === 'Sub-department') {
      this.openDialogSubDepartment('authority');
    } else if (userSelection === 'Floor') {
      this.openDialogFloor('authority');
  }
}

pageChanged(event: PageEvent) {
  this.totalItems = event.length;
  this.pageIndex = event.pageIndex;
  this.nextPage = event.pageSize;
  this.getAllAuthorityLocations();
}

getUserid() {
  return this.authService.decodedToken.nameid;
}

  getAllAuthorityLocations() {
      this.isLoading = true;
      this.setLoadingState(true);
      this.pageSize = this.pageSizeOptions[1];

      const obj: LocationPagingObject = {
        searchString: '',
        authoritylevel: '',
        sitelevel: '',
        locationlevel: '',
        departmentlevel: '',
        subDepartmentlevel: '',
        floorlevel: '',
        allLocations: '',
        userId: '',
        pageNumber: null,
        pageSize: null,
      };

      if (this.selectedSearchParameter === 'authoritylevel') {
        obj.authoritylevel = this.searchString.trim();
      }
      if (this.selectedSearchParameter === 'sitelevel') {
        obj.sitelevel = this.searchString.trim();
      }
      if (this.selectedSearchParameter === 'locationlevel') {
        obj.locationlevel = this.searchString.trim();
      }
      if (this.selectedSearchParameter === 'departmentlevel') {
        obj.departmentlevel = this.searchString.trim();
      }
      if (this.selectedSearchParameter === 'subDepartmentlevel') {
        obj.subDepartmentlevel = this.searchString.trim();
      }
      if (this.selectedSearchParameter === 'floorlevel') {
        obj.floorlevel = this.searchString.trim();
      }

      if (this.selectedSearchParameter === 'allLocations') {
        obj.allLocations = this.searchString;
      }

      obj.pageNumber = this.pageIndex;
      obj.pageSize = this.nextPage;

      obj.userId = this.getUserid();

      if (this.restrictDropDownParams()) {
        this.errorMessage = false;
        return this.authorityTreeService.getAllAuthorityLocations(obj).pipe(takeUntil(this.unsubscribe)).subscribe(
          (res: any) => {

            this.invalidSearch = res.headers.get('invalidsearch');

            if (res.body) {
              this.authority = res;
              for (const response of this.authority.body) {
                this.allAuthorities.push(response);
              }

              this.currentPage = JSON.parse(res.headers.get('pagination')).currentPage;
              this.itemsPerPage = JSON.parse(res.headers.get('pagination')).itemsPerPage;
              this.totalItems = JSON.parse(res.headers.get('pagination')).totalItems;
              this.totalPages = JSON.parse(res.headers.get('pagination')).totalPages;

              this.isLoading = false;
              this.setLoadingState(false);

              this.authorityFilter = false;
              this.MyDataSource = new MatTableDataSource<Element>(res);
              this.MyDataSource.data = res.body;
              this.MyDataSource.sort = this.sort;
            } else if (this.invalidSearch) {
                this.invalidSearchResultMessage(this.invalidSearch);
                this.errorMessage = true;
                this.isLoading = false;
                this.setLoadingState(false);
                this.MyDataSource !== undefined ? this.MyDataSource.data = [] : this.MyDataSource = null;
            }
          },
          error => {
            this.alertify.error('Something went wrong. Please try again later.');
            this.isLoading = false;
            this.setLoadingState(false);
          }
        );
      }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  selectRow(row) {
  }

  onUserSelectLevel1(event) {
    this.getLevel2DropDown();
  }

  onUserSelectLevel2(event) {
    this.getLevel3DropDown();
  }

  onUserSelectTopLevel(selectedAuthority) {
    this.getLevel1DropDown();
   }

  getLevel1DropDown() {
    return this.locationService.levelDropDown(this.selectedAuthority).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.level1Authorities = res;
    });
  }

  getLevel2DropDown() {
    return this.locationService.levelDropDown(this.selectedLevel1Authority).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.level2Authorities = res;
    });
  }

  getLevel3DropDown() {
    this.departmentCount = 0;
    if (this.departmentCount == 0) {
      this.hideLevel3DropDown = true;
    } 
    return this.locationService.levelDropDown(this.selectedLevel2Authority).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.level3Authorities = res;
    });
  }

  editClick(rootAuthorityUnitId) {
    return this.authorityTreeService.buildAuthorityTree(rootAuthorityUnitId).pipe(takeUntil(this.unsubscribe)).subscribe(
      res => {
        this.authorityTree = res;
        this.authorityTree.forEach(element => {
          this.authTreeArray.push(element);
        });

        this.MyDataSource = new MatTableDataSource();
        this.MyDataSource.data = this.authTreeArray;
        this.MyDataSource.sort = this.sort;
        this.MyDataSource.paginator = this.paginator;
      },
      error => {
        console.log('There was an error: ' + error);
      }
    );
  }

  restoreToDefaults() {
    this.selectedSearchParameter = 'allLocations';
    this.selectedParameter = 'allLocations';
    this.value = '';
    this.searchString = '';
    this.searchBarForm.controls['searchStringControl'].setValue('');
    this.disableSearchbox(); // Reset disabled state
    this.MyDataSource.data = [];
    this.allAuthorities = [];
  }

  openSiteEditPage(authority) {
    if (this.authService.decodedToken.role == 'Site Admin') {
      return null;
    } else {
      const dialogRef = this.dialog.open(EditSiteComponent, {
        width: '700px',
        data: {
          authority: authority
      }
      });
      dialogRef.afterClosed().subscribe(result => {
        // reset everything once the parent location is deleted
      if (dialogRef.componentInstance.isParentDeleted) {
        // restore default values
        this.restoreToDefaults();
        this.getAllAuthorityLocations();
      }
        // isModified comes from edit-site Component.
        // returns true or false
        if (dialogRef.componentInstance.isModified) {
          this.getAllAuthorityLocations();
        }
      });
    }
  }
}

export interface LocationPagingObject {
  searchString: string;
  authoritylevel: string;
  sitelevel: string;
  locationlevel: string;
  departmentlevel: string;
  subDepartmentlevel: string;
  floorlevel: string;
  allLocations: string;
  userId: string;
  pageNumber: number;
  pageSize: number;
}

export interface SearchObject {
  searchAuthorityLevel: string;
  searchSiteLevel: string;
  searchLocationLevel: string;
  searchDepartmentLevel: string;
  searchSubDepartmentLevel: string;
  searchFloorLevel: string;
}